var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguagesWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08317 6.12498L7.2915 4.54165H2.5415V3.52831C3.0165 3.25915 3.33317 2.75248 3.33317 2.16665C3.33317 1.29581 2.62067 0.583313 1.74984 0.583313C0.879004 0.583313 0.166504 1.29581 0.166504 2.16665C0.166504 2.75248 0.483171 3.25915 0.958171 3.52831V15.625H2.5415V12.4583H6.49984L7.2915 14.0416H12.8332V6.12498H8.08317ZM11.2498 12.4583H8.08317L7.2915 10.875H2.5415V6.12498H6.49984L7.2915 7.70831H11.2498V12.4583Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguagesWizardIcon);
export default __webpack_public_path__ + "static/media/languages-wizard-icon.f5d10430.svg";
export { ForwardRef as ReactComponent };